const TrashSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M3.5 4L4.41379 13.5948C4.46267 14.108 4.89373 14.5 5.40929 14.5H10.5907C11.1063 14.5 11.5373 14.108 11.5862 13.5948L12.5 4"
        stroke="#333333"
        strokeLinecap="round"
      />
      <path d="M2.5 4H13.5" stroke="#333333" strokeLinecap="round" />
      <path d="M6.5 6.50049L6.99945 11.9776" stroke="#333333" strokeLinecap="round" />
      <path d="M9.50098 6.50049L9.00055 11.9776" stroke="#333333" strokeLinecap="round" />
      <path d="M6 3.5V3C6 2.44772 6.44772 2 7 2H9C9.55228 2 10 2.44772 10 3V3.5" stroke="#333333" strokeLinecap="round" />
    </svg>
  );
};

export default TrashSvg;
